import { serializeMessageTemplate } from '../helpers/messageTemplateSerializer';

const TEMPLATE_DEFINITIONS = [
  {
    id: 'sales',
    icon: 'briefcase',
    stages: [
      {
        id: 'prospeccao',
        color: '#6366f1',
        icon: 'person-add',
        messages: ['WELCOME'],
      },
      {
        id: 'qualificacao',
        color: '#8b5cf6',
        icon: 'checkmark-circle',
        messages: ['MEETING'],
      },
      { id: 'proposta', color: '#ec4899', icon: 'document' },
      { id: 'fechamento', color: '#10b981', icon: 'heart-handshake' },
    ],
  },
  {
    id: 'support',
    icon: 'chat',
    stages: [
      {
        id: 'novo',
        color: '#6366f1',
        icon: 'add-circle',
        messages: ['RECEIVED'],
      },
      {
        id: 'analise',
        color: '#8b5cf6',
        icon: 'checkmark-circle',
        messages: ['STATUS'],
      },
      { id: 'desenvolvimento', color: '#ec4899', icon: 'code' },
      { id: 'teste', color: '#f59e0b', icon: 'flash-on' },
      { id: 'resolvido', color: '#10b981', icon: 'checkmark' },
    ],
  },
  {
    id: 'recruitment',
    icon: 'people',
    stages: [
      { id: 'triagem', color: '#6366f1', icon: 'filter' },
      { id: 'entrevista', color: '#8b5cf6', icon: 'people' },
      { id: 'teste', color: '#ec4899', icon: 'flash-on' },
      { id: 'proposta', color: '#10b981', icon: 'document' },
    ],
  },
  {
    id: 'realestate',
    icon: 'building-bank',
    stages: [
      { id: 'captacao', color: '#6366f1', icon: 'person-add' },
      { id: 'visita', color: '#8b5cf6', icon: 'location' },
      { id: 'negociacao', color: '#f59e0b', icon: 'credit-card-person' },
      { id: 'documentacao', color: '#ec4899', icon: 'book-copy' },
      { id: 'fechamento', color: '#10b981', icon: 'heart-handshake' },
    ],
  },
  {
    id: 'onboarding',
    icon: 'send',
    stages: [
      { id: 'boasvindas', color: '#6366f1', icon: 'emoji' },
      { id: 'configuracao', color: '#8b5cf6', icon: 'settings' },
      { id: 'treinamento', color: '#ec4899', icon: 'book' },
      { id: 'ativacao', color: '#10b981', icon: 'send' },
    ],
  },
  {
    id: 'marketing',
    icon: 'megaphone',
    stages: [
      { id: 'awareness', color: '#6366f1', icon: 'eye-show' },
      { id: 'interesse', color: '#8b5cf6', icon: 'star-emphasis' },
      { id: 'consideracao', color: '#f59e0b', icon: 'search' },
      { id: 'intencao', color: '#ec4899', icon: 'flame' },
      { id: 'conversao', color: '#10b981', icon: 'star-emphasis' },
    ],
  },
];

const COLOR_CLASSES = {
  '#6366f1': {
    badge: 'border-n-blue-5 bg-n-blue-3 text-n-blue-11',
    dot: 'bg-n-blue-9',
    icon: 'bg-n-blue-3 text-n-blue-11',
    accent: 'border-l-n-blue-9',
    column: 'border-n-blue-5 border-t-n-blue-9 bg-n-blue-2/50',
    text: 'text-n-blue-11',
    count: 'bg-n-blue-3 text-n-blue-11',
  },
  '#8b5cf6': {
    badge: 'border-n-violet-5 bg-n-violet-3 text-n-violet-11',
    dot: 'bg-n-violet-9',
    icon: 'bg-n-violet-3 text-n-violet-11',
    accent: 'border-l-n-violet-9',
    column: 'border-n-violet-5 border-t-n-violet-9 bg-n-violet-2/50',
    text: 'text-n-violet-11',
    count: 'bg-n-violet-3 text-n-violet-11',
  },
  '#ec4899': {
    badge: 'border-n-ruby-5 bg-n-ruby-3 text-n-ruby-11',
    dot: 'bg-n-ruby-9',
    icon: 'bg-n-ruby-3 text-n-ruby-11',
    accent: 'border-l-n-ruby-9',
    column: 'border-n-ruby-5 border-t-n-ruby-9 bg-n-ruby-2/50',
    text: 'text-n-ruby-11',
    count: 'bg-n-ruby-3 text-n-ruby-11',
  },
  '#f59e0b': {
    badge: 'border-n-amber-5 bg-n-amber-3 text-n-amber-11',
    dot: 'bg-n-amber-9',
    icon: 'bg-n-amber-3 text-n-amber-11',
    accent: 'border-l-n-amber-9',
    column: 'border-n-amber-5 border-t-n-amber-9 bg-n-amber-2/50',
    text: 'text-n-amber-11',
    count: 'bg-n-amber-3 text-n-amber-11',
  },
  '#10b981': {
    badge: 'border-n-teal-5 bg-n-teal-3 text-n-teal-11',
    dot: 'bg-n-teal-9',
    icon: 'bg-n-teal-3 text-n-teal-11',
    accent: 'border-l-n-teal-9',
    column: 'border-n-teal-5 border-t-n-teal-9 bg-n-teal-2/50',
    text: 'text-n-teal-11',
    count: 'bg-n-teal-3 text-n-teal-11',
  },
};

const DEFAULT_COLOR_CLASSES = {
  badge: 'border-n-weak bg-n-alpha-2 text-n-slate-11',
  dot: 'bg-n-slate-9',
  icon: 'bg-n-alpha-2 text-n-slate-11',
  accent: 'border-l-n-slate-9',
  column: 'border-n-weak border-t-n-slate-9 bg-n-alpha-1',
  text: 'text-n-slate-11',
  count: 'bg-n-alpha-2 text-n-slate-11',
};

const PIPELINE_STAGE_TEMPLATE_FIELDS = [
  'name',
  'description',
  'color',
  'icon',
  'position',
  'is_entry_stage',
  'is_won_stage',
  'is_lost_stage',
  'automation_actions',
  'wip_limit',
  'sla_hours',
  'message_templates',
];

const PIPELINE_SETTINGS_TEMPLATE_FIELDS = [
  'card_display_fields',
  'automations',
  'notifications',
  'visibility',
  'sort_order',
  'default_filter',
  'quick_values',
  'label_stage_mappings',
  'stage_label_mappings',
  'auto_assignment',
  'require_loss_reason',
  'enable_won_lost_stages',
  'require_won_value',
  'lead_scoring',
  'agents',
  'auto_archive_on_resolved',
  'auto_win_on_resolved',
];

const PIPELINE_TEMPLATE_MESSAGE_FIELDS = [
  'title',
  'content',
  'category',
  'conditions',
];

const cloneTemplateValue = value => {
  if (Array.isArray(value)) return value.map(cloneTemplateValue);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [
        key,
        cloneTemplateValue(nestedValue),
      ])
    );
  }
  return value;
};

const pickTemplateFields = (source, fields) =>
  Object.fromEntries(
    fields
      .filter(field => source?.[field] !== undefined)
      .map(field => [field, cloneTemplateValue(source[field])])
  );

// Converts presentation presets into the API/form contract. Template-only
// metadata (top-level id/icon) is intentionally excluded and every nested
// value is cloned so edits in a draft cannot mutate the shared preset.
export const normalizePipelineTemplateData = template => ({
  name: String(template?.name || ''),
  description: String(template?.description || ''),
  stages: Object.fromEntries(
    Object.entries(template?.stages || {}).map(([stageId, stage]) => {
      const serializedStage = pickTemplateFields(
        stage,
        PIPELINE_STAGE_TEMPLATE_FIELDS
      );
      if (Array.isArray(serializedStage.message_templates)) {
        serializedStage.message_templates = serializedStage.message_templates
          .filter(message => message && typeof message === 'object')
          .map(message =>
            pickTemplateFields(message, PIPELINE_TEMPLATE_MESSAGE_FIELDS)
          );
      }
      return [stageId, serializedStage];
    })
  ),
  settings: pickTemplateFields(
    template?.settings || {},
    PIPELINE_SETTINGS_TEMPLATE_FIELDS
  ),
});

const translationPath = (...parts) =>
  `PIPELINE.TEMPLATES_LIBRARY.PRESETS.${parts
    .map(part => String(part).toUpperCase())
    .join('.')}`;

/* eslint-disable @intlify/vue-i18n/no-dynamic-keys -- preset identifiers are a closed local registry with en/pt_BR parity */
export const buildPipelineTemplates = (t, timestamp = Date.now()) =>
  TEMPLATE_DEFINITIONS.map((template, templateIndex) => {
    const stages = Object.fromEntries(
      template.stages.map((stage, stageIndex) => {
        const messages = (stage.messages || []).map((message, messageIndex) =>
          serializeMessageTemplate({
            id: `template_${timestamp}_${templateIndex}_${stageIndex}_${messageIndex}`,
            title: t(
              translationPath(template.id, 'MESSAGES', message, 'TITLE')
            ),
            content: t(
              translationPath(template.id, 'MESSAGES', message, 'CONTENT')
            ),
            conditions: { rules: [], enabled: false },
            created_at: new Date(timestamp).toISOString(),
          })
        );

        return [
          stage.id,
          {
            id: stage.id,
            name: t(translationPath(template.id, 'STAGES', stage.id, 'NAME')),
            description: t(
              translationPath(template.id, 'STAGES', stage.id, 'DESCRIPTION')
            ),
            color: stage.color,
            icon: stage.icon,
            position: stageIndex + 1,
            message_templates: messages,
          },
        ];
      })
    );

    return {
      id: template.id,
      name: t(translationPath(template.id, 'NAME')),
      description: t(translationPath(template.id, 'DESCRIPTION')),
      icon: template.icon,
      stages,
      settings: { agents: [] },
    };
  });
/* eslint-enable @intlify/vue-i18n/no-dynamic-keys */

export const getStageColorClasses = color =>
  COLOR_CLASSES[String(color || '').toLowerCase()] || DEFAULT_COLOR_CLASSES;
